import React from 'react';
import { AlertCircleIcon, CheckIcon } from 'lucide-react';
import { volumes } from '../../data/volumes';
import { CTAButton } from '../CTAButton';
export function Volumes() {
  return <section className="w-full bg-navy-950 py-14 text-white md:py-20" aria-labelledby="volumes-title" data-id="element-273" data-mp="2x105gstbq75e">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-274" data-mp="2szybaqe9klaa">
        <div className="text-center" data-id="element-275" data-mp="2szey1mzk6l2l">
          <h2 id="volumes-title" className="font-display text-[26px] font-black uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-276" data-mp="2o0brfy3xk6si">
            What’s Inside Aligner Case Commander™?
          </h2>
          <p className="mt-3 font-display text-[12px] font-bold uppercase tracking-[0.2em] text-brand-400 sm:text-sm" data-id="element-277" data-mp="2ebk2lyu622lt">
            The 6-volume visual case system
          </p>
        </div>

        <div className="mt-8 space-y-4 md:mt-12 md:space-y-6" data-id="element-278" data-mp="2592dncn4mvv4">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-279" data-mp="20c29j79u836n">
              <div className="border-b border-white/10 bg-brand-600 px-5 py-2.5" data-id="element-280" data-mp="37wcm6tv7gyjy">
                <span className="font-display text-[11px] font-black uppercase tracking-[0.24em] text-white" data-id="element-281" data-mp="37y77486h8qo1">
                  {volume.number}
                </span>
              </div>

              <div className="px-5 py-6 sm:px-7" data-id="element-282" data-mp="2y4gk77q00oag">
                <h3 className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl" data-id="element-283" data-mp="3lvvq1agzhnqg">
                  {volume.title}
                </h3>
                <p className="mt-2 font-display text-[14px] font-bold leading-snug text-brand-400 sm:text-base" data-id="element-284" data-mp="3cvfq2azg8yqc">
                  {volume.subtitle}
                </p>
                <p className="mt-3 text-[14px] leading-relaxed text-brand-100/80 sm:text-[15px]" data-id="element-285" data-mp="3hspblfjpwq8w">
                  {volume.description}
                </p>

                <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.18em] text-white/50" data-id="element-286" data-mp="26fwpak9p4u08">
                  Inside you’ll find
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-287" data-mp="c19f61k1j47h">
                  {volume.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-288" data-mp="29bxqd2fvg0b">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-289" data-mp="27inyowj4fo3" />
                      <span className="text-[14px] font-medium leading-snug text-white" data-id="element-290" data-mp="3ub1qsvg12z6z">{item}</span>
                    </li>)}
                </ul>

                {volume.note && <p className="mt-5 flex items-start gap-2 rounded-xl bg-navy-950/60 px-3.5 py-3 text-[11px] leading-relaxed text-brand-100/70" data-id="element-291" data-mp="3kh1by1uy2fl2">
                    <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-292" data-mp="3bf1z7lqypxnx" />
                    {volume.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-293" data-mp="19ksut3xi0t1b">
          <CTAButton tone="gold" onDark data-id="element-294" data-mp="2rlboj4r98jsb" />
        </div>
      </div>
    </section>;
}